import { render, staticRenderFns } from "./AdminGroups.vue?vue&type=template&id=426feabd&"
import script from "./AdminGroups.vue?vue&type=script&lang=js&"
export * from "./AdminGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports